import { useCallback, useEffect, useState } from 'react'

export const useScrollLock = () => {
  const [scrollLockCount, setScrollLockCount] = useState(0)

  const setScrollLock = useCallback((isLocked: boolean) => {
    setScrollLockCount((prev) => {
      const newCount = isLocked ? prev + 1 : Math.max(0, prev - 1)
      return newCount
    })
  }, [])

  // 💊 below effect should not be easily changed
  // 💊 because it will break the "WHOLE" app
  useEffect(() => {
    const body = document.body

    if (scrollLockCount > 0) {
      body.classList.add('overflow-hidden')
    }

    return () => {
      body.classList.remove('overflow-hidden')
    }
  }, [scrollLockCount])

  // 💊 below effect should not be easily changed
  // 💊 because it will break the "WHOLE" app
  useEffect(() => {
    const html = document.documentElement

    html.classList.add('no-scrollbar')

    return () => {
      html.classList.remove('no-scrollbar')
    }
  }, [])

  return {
    setScrollLock,
  }
}
